import { IInitAction } from './init'

export enum types {
  GET_DATASREAM_ALLOWED_DOMAINS__START = 'GET_DATASREAM_ALLOWED_DOMAINS__START',
  GET_DATASREAM_ALLOWED_DOMAINS__SUCCESS = 'GET_DATASREAM_ALLOWED_DOMAINS__SUCCESS',
  GET_DATASREAM_ALLOWED_DOMAINS__FAILURE = 'GET_DATASREAM_ALLOWED_DOMAINS__FAILURE',
  GET_DATASREAM_ALLOWED_DOMAINS__CANCEL = 'GET_DATASREAM_ALLOWED_DOMAINS__CANCEL',
}

export interface IServerConfig {
  isLoading: boolean
  allowedDomains: string[]
}

export interface IGetDataStreamAllowedDomainsAction {
  type: types.GET_DATASREAM_ALLOWED_DOMAINS__START
}

export interface IGetDataStreamAllowedDomainsSuccessAction {
  type: types.GET_DATASREAM_ALLOWED_DOMAINS__SUCCESS
  domains: string[]
}

export interface IGetDataStreamAllowedDomainsFailureAction {
  type: types.GET_DATASREAM_ALLOWED_DOMAINS__FAILURE
  message: string
}
export interface IGetDataStreamAllowedDomainsCancelAction {
  type: types.GET_DATASREAM_ALLOWED_DOMAINS__CANCEL
}

export type ConfigActionsType =
  | IGetDataStreamAllowedDomainsAction
  | IGetDataStreamAllowedDomainsSuccessAction
  | IGetDataStreamAllowedDomainsFailureAction
  | IGetDataStreamAllowedDomainsCancelAction
  | IInitAction
